export default "__VITE_ASSET__BSDbMVmU__"